export default class statusMessage {
	constructor()
	{
		this.init();
	}

	mode(mode)
	{
		switch (mode)
		{
			case 'error':
				this.statusMessage.dataset.mode = 'error';
				break;

			case 'warning':
				this.statusMessage.dataset.mode = 'warning';
				break;

			case 'info':
				this.statusMessage.dataset.mode = 'info';
				break;

			case 'success':
				this.statusMessage.dataset.mode = 'success';
				break;

			default:
				this.statusMessage.dataset.mode = 'neutral';
				break;
		}
	}

	// Change icon
	icon(iconId)
	{
		this._icon.setAttribute('class', 'icon ' + iconId);
		this._icon.querySelector('use').setAttribute('href', '#' + iconId);
	}

	working()
	{
		console.warn('The `working()` method is deprecated, in favor of `mode()` and `icon()`.')
		this.statusMessage.classList.replace('-ready', '-working');
		// Change icon
		this._icon.classList.replace('icon-check', 'icon-spinner');
		this._icon.querySelector('use').setAttribute('href', '#icon-spinner');
	}

	ready()
	{
		console.warn('The `ready()` method is deprecated, in favor of `mode()` and `icon()`.')
		this.statusMessage.classList.replace('-working', '-ready');
		// Change icon
		this._icon.classList.replace('icon-spinner', 'icon-check');
		this._icon.querySelector('use').setAttribute('href', '#icon-check');
	}

	text(text)
	{
		this.statusMessage.querySelector('p').innerHTML = text;
	}

	show()
	{
		this.statusMessage.classList.remove('-hidden');
	}

	hide()
	{
		this.statusMessage.classList.add('-hidden');
	}

	init()
	{
		this.statusMessage = document.querySelector('.jsStatusMessage');
		this._icon = this.statusMessage.querySelector('.icon');
	}
}